import React, { useState, useEffect, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { imageArticleUrl } from "../../utils/modules";
import { useNavigate, useLocation } from "react-router-dom";
import { villesMadagascar } from "../../constant/villesMadagascar";
import { FiCamera } from "react-icons/fi";
import { AuthContext } from "../../contexts/AuthContext.js";
import useGroupeCategorie from "../../hooks/useGroupeCategorie";
import useArticles from "../../hooks/useArticle";
import useCategorie from "../../hooks/useCategorie";
import { rotateFileWithCanvas } from "../../utils/gestionImage.js";
import { validateField, isButtonDisabled } from "../../utils/validators";
const ArticleUpdate = ({ setAlert }) => {
  //    STATE
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [categoriGroup, setCategoriGroup] = useState([]);
  const [loadingOne, setLoadingOne] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [infoValue, setInfoValue] = useState("");
  const [infoCle, setInfoCle] = useState([]);
  const [formArticle, setFormArticle] = useState({});
  const [categories, setCategories] = useState([]);
  const [isLoadingCategorie, setIsLoadingCategorie] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [activeGroup, setActiveGroup] = useState(null);
  const [allChampValide, setAllChampValide] = useState(true);
  const [hasPrice, setHasPrice] = useState(2); // 1 = Oui, 2 = Non
  const [photos, setPhotos] = useState([]);
  const [errors, setErrors] = useState({
    titre: false,
    pseudo: false,
  });
  // ✅ Option B : rotation des anciennes photos
  // index -> angle (0/90/180/270)
  const [oldPhotosRotation, setOldPhotosRotation] = useState({});

  const location = useLocation();
  const from = location.state?.from;
  const { getAllGroupCategories } = useGroupeCategorie();
  const { user } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id") || "";
  const navigate = useNavigate();
  const { findOneArticle, updateArticle } = useArticles();
  const { getAllCategories } = useCategorie();
  const generateId = () => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }

    return `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
  };
  //   USEEFFECT
  useEffect(() => {
    setIsLoadingCategorie(true);
    getAllCategories()
      .then((res) => {
        if (res?.data?.data && res?.data?.data.length > 0) {
          setCategories(res.data.data);
        }
        setIsLoadingCategorie(false);
      })
      .catch((err) => {
        setIsLoadingCategorie(false);
        setAlert?.({
          message:
            "Une erreur s'est produite lors de la récupération des données.",
          type: "danger",
        });
        console.log(err);
      });

    getAllGroupCategories()
      .then((res) => {
        if (res?.data?.data && res?.data?.data.length > 0) {
          const activeGroups = res.data.data.filter(
            (group) => group.archive === 2,
          );
          setCategoriGroup(activeGroups);
        }
      })
      .catch((err) => {
        console.log(err);
        setAlert?.({
          message:
            "Une erreur s'est produite lors de la récupération des données.",
          type: "danger",
        });
      });
  }, []);

  useEffect(() => {
    if (!id) return;
    setLoadingOne(true);
    findOneArticle(id)
      .then((res) => {
        if (res?.data?.data) {
          const article = res.data.data;
          if (article.photos && article.photos.length > 0) {
            const formatted = article.photos.map((p, i) => {
              return {
                id: generateId(),
                file: null,
                url: `${imageArticleUrl}/${p}`,
                rotation: 0,
                isNew: false,
              };
            });
            setPhotos(formatted);
          }
          setFormArticle({
            ...article,
            oldPhotos: article.photos || [],
            photos: [],
          });
          setSelectedGroupId(article.categorie.idCategorieGroupe || "");
          setOldPhotosRotation({});
        } else {
          setFormArticle(undefined);
        }
        setLoadingOne(false);
      })
      .catch((err) => {
        setLoadingOne(false);
        setAlert?.({
          message:
            "Une erreur s'est produite lors de la récupération des données de l'annonce.",
          type: "danger",
        });
        console.error("Erreur lors de la récupération de l'article :", err);
      });
  }, [id]);

  //   FUNCTIONS
  const maxPhotos = Number(formArticle.typeAbonnement) === 1 ? 10 : 10;

  const handleRemovePhoto = (id) => {
    const newPhoto = photos.filter((photo) => photo.id != id);
    setPhotos(newPhoto);
  };

  const handlePhotos = async (e) => {
    const files = Array.from(e.target.files);

    const newPhotos = files.map((file) => ({
      id: generateId(),
      file,
      url: URL.createObjectURL(file),
      rotation: 0,
      isNew: true,
    }));

    const lengthNewPhoto = newPhotos.length;
    const totalImage = lengthNewPhoto + photos.length;
    if (totalImage > 10) {
      setAlert?.({
        message: "Limite images atteint (10 Max)",
        type: "danger",
      });
    } else {
      setPhotos((prev) => [...prev, ...newPhotos]);
    }
  };

  const handleAddInfoCle = () => {
    if (!selectedIcon || !infoValue.trim()) return;

    setInfoCle((prev) => [
      ...prev,
      {
        icon: selectedIcon.icon,
        name: selectedIcon.label,
        value: infoValue,
      },
    ]);

    setSelectedIcon(null);
    setInfoValue("");
  };

  const handleRemoveInfoCle = (index) => {
    setInfoCle((prev) => prev.filter((_, i) => i !== index));
  };

  const movePhoto = (index, direction) => {
    setPhotos((prev) => {
      const arr = [...prev];
      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= arr.length) return prev;

      [arr[index], arr[newIndex]] = [arr[newIndex], arr[index]];
      return arr;
    });
  };

  // ✅ Option B : tourner une ancienne photo (metadata)
  const rotatePhoto = async (id, step = 90) => {
    let photoCible = photos.find((photo) => photo.id == id);
    // console.log(photoCible);
    if (photoCible.file) {
      const newPhotoRotated = await rotateFileWithCanvas(
        photoCible.url,
        photoCible.file,
        step,
      );
      const newUrl = URL.createObjectURL(newPhotoRotated);
      photoCible.url = newUrl;
      photoCible.file = newPhotoRotated;
      let newPhoto = photos.map((photo) => {
        if (photo.id == id) {
          return photoCible;
        } else {
          return photo;
        }
      });
      setPhotos(newPhoto);
    } else {
      photoCible.rotation = photoCible.rotation + step;
      let newPhoto = photos.map((photo) => {
        if (photo.id == id) {
          return photoCible;
        } else {
          return photo;
        }
      });
      setPhotos(newPhoto);
    }
  };

  const handleUpdateChange = (e) => {
    const { name, value } = e.target;

    setFormArticle((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const goBack = () => {
    if (from) {
      if (from.includes("step=2")) {
        return navigate(from, { replace: true });
      }
      return navigate(from + "?step=2", { replace: true });
    }

    return navigate(`/article/visualisation/${id}`);
  };

  const handleConfirmUpdate = async () => {
    setUpdateLoading(true);

    const fd = new FormData();
    if (hasPrice != 1) {
      if (
        !formArticle?.prix ||
        isNaN(Number(formArticle.prix)) ||
        Number(formArticle.prix) <= 0
      ) {
        formArticle.prix = 0;
      }
    }

    let existingPhotos = [];
    let oldPhotoRotations = [];
    let ordreUpload = [];
    // let newPhoto = [];
    if (photos.length > 0) {
      photos.forEach((p) => {
        if (p.file) {
          fd.append("photos", p.file);
          ordreUpload.push("N");
        } else {
          const imageName = p.url.split("./files")[1];
          existingPhotos.push(`./files${imageName}`);
          oldPhotoRotations.push(p.rotation);
          ordreUpload.push(imageName);
        }
      });
      fd.append("existingPhotos", JSON.stringify(existingPhotos));
      fd.append("oldPhotosRotation", JSON.stringify(oldPhotoRotations));
    }
    fd.append("ordreUpload", JSON.stringify(ordreUpload));
    Object.keys(formArticle).forEach((key) => {
      if (
        key == "nbVue" ||
        key == "nbFavoris" ||
        key == "nbMessage" ||
        key == "nbAppel" ||
        key == "nbPartageWathsapp" ||
        key == "nbPartageFacebook" ||
        key == "nbWhatsapp"
      ) {
        // ignore
      } else {
        if (key === "infoCle") {
          fd.append("infoCle", JSON.stringify(formArticle.infoCle || []));
        } else if (
          key != "photos" &&
          key != "oldPhotos" &&
          key != "existingPhotos" &&
          key != "oldPhotosRotation"
        ) {
          fd.append(key, formArticle[key]);
        }
      }
    });

    // nouvelles photos
    // formArticle.photos?.forEach((p) => fd.append("photos", p));

    // anciennes photos gardées / ordre
    // fd.append("existingPhotos", JSON.stringify(formArticle.oldPhotos || []));

    // ✅ Option B : rotations anciennes photos
    // fd.append("oldPhotosRotation", JSON.stringify(oldPhotosRotation));

    // for (let [key, value] of fd.entries()) {
    //   if (value instanceof File) {
    //     console.log(key, "📁 File:", value.name);
    //   } else {
    //     console.log(key, value);
    //   }
    // }

    // setUpdateLoading(false);
    // return;

    try {
      await updateArticle(formArticle._id, fd)
        .then(() => {
          setAlert?.({
            message: "Annonce modifiée avec succèss",
            type: "success",
          });
          goBack();
        })
        .catch((err) => {
          console.log(err);
          setAlert?.({
            message: "Erreur lors de la modification",
            type: "danger",
          });
        });
    } catch (err) {
      console.error(err.message);
      setAlert?.({ message: "Erreur lors de la modification", type: "danger" });
    } finally {
      setUpdateLoading(false);
    }
  };

  const filteredCategories = selectedGroupId
    ? categories.filter((cat) => cat.idCategorieGroupe?._id === selectedGroupId)
    : "";

  useEffect(() => {
    const selectedCat = categories.find(
      (cat) => cat._id === formArticle.idCategorie,
    );
    const havingPrice = selectedCat?.hasPrice === 1; // 1 = Oui, 2 = Non
    setHasPrice(havingPrice ? 1 : 2);
  }, [formArticle.idCategorie, categories]);

  const formatThousands = (value) => {
    if (value === null || value === undefined) return "";
    const raw = String(value).replace(/[^\d]/g, "");
    if (raw === "") return "";
    if (raw === "0") return "0";
    return Number(raw).toLocaleString("fr-FR");
  };

  const handlePriceChange = (e) => {
    const raw = e.target.value.replace(/[^\d]/g, "");
    setFormArticle((prev) => ({
      ...prev,
      prix: raw,
    }));
  };

  const isupdateDisabled = () => {
    if (
      !formArticle.titre ||
      !formArticle.description ||
      !formArticle.pseudo ||
      !formArticle.ville ||
      !formArticle.quartier
    ) {
      return true;
    }
    if (hasPrice === 1 && (!formArticle.prix || formArticle.prix === "0")) {
      return true;
    }
    return false;
  };

  return (
    <div className="container mt-5 mb-5">
      <i
        className="bi bi-x-circle login_icon_x"
        role="button"
        onClick={goBack}
      />
      <div className="article_create_header">
        <h1 className="article_create_title">Modifiez l'annonce</h1>
      </div>

      <h6 className="fw-bold mb-2">
        <FiCamera /> Photos (Max {maxPhotos})
      </h6>

      <div className="photo-flex-container mt-5">
        {photos.map((p, i) => (
          <div key={p.id} className="photo-card-flex">
            <img
              src={p.url}
              className="photo-uploaded"
              alt="upload"
              style={{
                transform: `rotate(${p.rotation}deg)`,
                transition: "transform .2s ease",
              }}
            />

            <div className="photo-controls">
              <button onClick={() => movePhoto(i, -1)} disabled={i === 0}>
                ←
              </button>

              <button onClick={() => rotatePhoto(p.id, -90)}>⟲</button>
              <button onClick={() => rotatePhoto(p.id, 90)}>⟳</button>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemovePhoto(p.id);
                }}
                className="btn-del"
              >
                <i className="bi bi-trash3"></i>
              </button>

              <button
                onClick={() => movePhoto(i, 1)}
                disabled={i === photos.length - 1}
              >
                →
              </button>
            </div>

            {i === 0 && (
              <span className="main_label_principale">couverture</span>
            )}
            <span
              className="main_label_principale bg-danger "
              style={{ top: "0", left: "auto", right: "0" }}
            >
              {i + 1}
            </span>
          </div>
        ))}

        {photos.length < 10 && (
          <label className="photo-upload-card-flex">
            <div className="content-btn-add-photo">
              {/* <span>{10 - photos.length} supplémentaires</span> */}
              <span>Ajouter plus d'images</span>
              <i className="bi bi-image icon_add_photo"></i>
              <input
                type="file"
                multiple
                hidden
                onChange={handlePhotos}
                accept="image/*"
              />
              {/* <span>{amount.toLocaleString()} MGA</span> */}
            </div>
          </label>
        )}
      </div>

      <hr />

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Titre *</label>
          <input
            type="text"
            name="titre"
            className={`form-control custom_css_field_update ${errors.titre ? "is-invalid" : ""
              }`}
            defaultValue={formArticle.titre || ""}
            onBlur={(e) =>
              validateField({
                e,
                minLength: 4,
                label: "titre",
                setErrors,
                handleUpdateChange,
                setAlert,
              })
            }
            required
          />
          {errors.titre && (
            <div className="invalid-feedback">
              Le titre doit contenir au moins 4 caractères
            </div>
          )}
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Pseudo *</label>
          <input
            type="text"
            name="pseudo"
            className={`form-control custom_css_field_update ${errors.pseudo ? "is-invalid" : ""
              }`}
            defaultValue={formArticle.pseudo || ""}
            onBlur={(e) =>
              validateField({
                e,
                minLength: 4,
                label: "pseudo",
                setErrors,
                handleUpdateChange,
              })
            }
            placeholder="Ex: Achille"
            required
          />
          {errors.pseudo && (
            <div className="invalid-feedback">
              Le pseudo doit contenir au moins 4 caractères
            </div>
          )}
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">Description *</label>
        <textarea
          name="description"
          rows="4"
          className="form-control custom_css_field_update"
          value={formArticle.description || ""}
          onChange={handleUpdateChange}
          required
        />
      </div>

      <div className="row">
        <div className={`col-md-6 mb-3 ${hasPrice == 2 ? "d-none" : ""}`}>
          <label className="form-label">Prix</label>
          <input
            type="text"
            name="prix"
            className="form-control custom_css_field_update"
            value={formatThousands(formArticle.prix)}
            onChange={handlePriceChange}
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder="Ex: 1 200 000"
            required
          />
        </div>

        <div
          className={`${hasPrice == 2 ? "col-md-12 mb-3" : "col-md-6 mb-3"}`}
        >
          <label className="form-label">État *</label>
          <select
            name="etat"
            className="form-select custom_css_field_update"
            value={formArticle.etat}
            onChange={handleUpdateChange}
          >
            <option value={1}>Neuf</option>
            <option value={2}>Occasion</option>
          </select>
        </div>
      </div>

      <div className="row">
        {user?.role === 1 && (
          <div className="col-md-6 mb-3">
            <div className="mb-3">
              <label className="form-label">Groupe Catégorie *</label>
              <select
                value={selectedGroupId}
                onChange={(e) => setSelectedGroupId(e.target.value)}
                className="form-select custom_css_field_update"
              >
                <option value="">Tous les groupes</option>

                {categoriGroup
                  .sort((a, b) => a.rang - b.rang)
                  .map((group) => (
                    <option key={group._id} value={group._id}>
                      {group.nom}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        )}
        <div className={user?.role === 1 ? "col-md-6 mb-3" : "col-md-12 mb-3"}>
          <div className="mb-3">
            <label className="form-label">Catégorie *</label>
            <select
              name="idCategorie"
              className="form-select custom_css_field_update"
              value={formArticle.idCategorie || ""}
              onChange={handleUpdateChange}
            >
              <option value="">-- Veuillez choisir une catégorie --</option>
              {filteredCategories != "" &&
                filteredCategories
                  .sort((a, b) => a.rang - b.rang)
                  .map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat.nom}
                    </option>
                  ))}
            </select>
            {/* Ajouter ici la nouveau design */}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Ville</label>
          <select
            name="ville"
            value={formArticle.ville}
            onChange={handleUpdateChange}
            className="form-select custom_css_field_update"
          >
            <option value="">Choisir une ville</option>
            {[...villesMadagascar].sort().map((ville, index) => (
              <option key={index} value={ville}>
                {ville}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Quartier</label>
          <input
            type="text"
            name="quartier"
            className="form-control custom_css_field_update"
            value={formArticle.quartier || ""}
            onChange={handleUpdateChange}
          />
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">Téléphone</label>
        <input
          type="text"
          name="phone"
          className="form-control custom_css_field_update"
          value={formArticle.phone || ""}
          onChange={handleUpdateChange}
        />
      </div>

      {user?.role === 1 && (
        <>
          <hr />
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Type Offre</label>
              <select
                name="typeOffre"
                className="form-select custom_css_field_update"
                value={formArticle.typeOffre}
                onChange={handleUpdateChange}
              >
                <option value={1}>Offre</option>
                <option value={2}>Demande</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Type Abonnement</label>
              <select
                name="typeAbonnement"
                className="form-select custom_css_field_update"
                value={formArticle.typeAbonnement}
                onChange={handleUpdateChange}
              >
                <option value={1}>Premium</option>
                <option value={2}>Standard</option>
              </select>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">Id Publication Facebook</label>
              <input
                type="text"
                name="idPublicationFacebook"
                className="form-control custom_css_field_update"
                value={formArticle.idPublicationFacebook || ""}
                onChange={handleUpdateChange}
              />
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">Date d'expiration</label>
              <input
                type="date"
                name="dateExpiration"
                className="form-control custom_css_field_update"
                value={
                  formArticle.dateExpiration
                    ? new Date(formArticle.dateExpiration)
                      .toISOString()
                      .substring(0, 10)
                    : ""
                }
                onChange={handleUpdateChange}
              />
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">Article test</label>
              <select
                name="isTest"
                className="form-select custom_css_field_update"
                value={formArticle.isTest}
                onChange={handleUpdateChange}
              >
                <option value={1}>Oui</option>
                <option value={2}>Non </option>
              </select>
            </div>
          </div>
        </>
      )}

      <hr />

      {(user.role == 1 || user.role == 2)&& (
        <>

          <button
            className={`btn article_create_btn_continuer mt-4 mb-5`}
            onClick={handleConfirmUpdate}
            disabled={
              updateLoading ||
              isButtonDisabled(errors) ||
              (hasPrice == 1 && formArticle.prix == 0)
            }
            style={{ width: "200px", float: "right" }}
          >
            {updateLoading ? "Enregistrement..." : "Enregistrer"}
          </button>
        </>

      )}

      {previewImage && (
        <div
          className="image-preview-overlay"
          onClick={() => setPreviewImage(null)}
        >
          <img src={previewImage} alt="preview" />
        </div>
      )}
    </div>
  );
};

export default ArticleUpdate;

// Note: Ce code est une proposition d'implémentation pour la page de mise à jour d'une annonce. Il peut nécessiter des ajustements en fonction de la structure exacte de votre projet et de vos besoins spécifiques.
{
  /* <div className="custom-category-select">
    <div
      className="category-input-display"
      onClick={() => setShowCategoryModal(true)}
    >
      {formArticle.idCategorie
        ? categories.find((c) => c._id === formArticle.idCategorie)?.nom
        : "Catégorie"}
    </div>

    {showCategoryModal && (
      <div className="category-modal-overlay">
        <div className="category-modal-box">
          <div className="category-left">
            {categoriGroup
              .sort((a, b) => a.rang - b.rang)
              .map((group) => {
                const isActive = activeGroup?._id === group._id;

                return (
                  <div
                    key={group._id}
                    className={`category-group-item ${
                      isActive ? "active" : ""
                    }`}
                    onClick={() => setActiveGroup(group)}
                  >
                    <span>{group.nom}</span>
                    {isActive && (
                      <span className="fleche-icon">
                        <i className="bi bi-caret-right-fill"></i>
                      </span>
                    )}
                  </div>
                );
              })}
          </div>

          <div className="category-right">
            {activeGroup &&
              categories
                .filter(
                  (cat) =>
                    cat.idCategorieGroupe?._id === activeGroup._id,
                )
                .sort((a, b) => a.rang - b.rang)
                .map((cat) => (
                  <div
                    key={cat._id}
                    className={`category-sub-item ${
                      formArticle.idCategorie === cat._id
                        ? "selected-sub"
                        : ""
                    }`}
                    onClick={() => {
                      handleUpdateChange({
                        target: {
                          name: "idCategorie",
                          value: cat._id,
                        },
                      });
                      setShowCategoryModal(false);
                    }}
                  >
                    {cat.nom}
                  </div>
                ))}
          </div>

          <button
            className="category-close-btn"
            onClick={() => setShowCategoryModal(false)}
          >
            ✕
          </button>
        </div>
      </div>
    )}
  </div> */
}
